import React from "react";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
export function ConfirmProfileSaveModal(props) {
  const JSX = (
    <Modal
      isOpen={props.modal}
      toggle={props.toggle}
      className={"modal-dialog modal-dialog-centered modal-md"}
    >
      <ModalBody className="text-center">
        <p class="text-center m-0 font-weight-regular">
          Confirm Profile
          <span class="highlight-text"> Update </span>?
        </p>
      </ModalBody>
      <ModalFooter>
        <button
          type="button"
          class="btn btn-sm btn-primary"
          onClick={props.onYes}
        >
          Yes
        </button>
        <button type="button" class="btn btn-sm btn-dark" onClick={props.onNo}>
          No
        </button>
        <div class="mt-3"></div>
      </ModalFooter>
    </Modal>
  );
  return JSX;
}
